module.exports = __webpack_public_path__ + "static/gb-wls-9f7c50cf094d59a85e35b3ee0a211341.svg";